import { getDailyData } from "../api/LWRN/getDailyData.ts"
import { getFlowRateDisplayData } from "../api/LWRN/getFlowRateDisplayData.ts"
import { getMonthlyData } from "../api/LWRN/getMonthlyData.ts"

import type { SummaryRowConfig } from "../types/summaryRowTypes.ts"

export const LWRNFetchers: SummaryRowConfig = {
  flowRateFetcher: getFlowRateDisplayData,
  dailyFetcher: getDailyData,
  monthlyFetcher: getMonthlyData,
  flowThresholds: [1000, 1400, 1700, 2000],
}
